import { render, staticRenderFns } from "./PH2Z.vue?vue&type=template&id=b4fd3252&scoped=true"
import script from "./PH2Z.vue?vue&type=script&lang=js"
export * from "./PH2Z.vue?vue&type=script&lang=js"
import style0 from "./PH2Z.vue?vue&type=style&index=0&id=b4fd3252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fd3252",
  null
  
)

export default component.exports